module.exports = __webpack_public_path__ + "static/media/draw-square.02eccf1b.svg";